import React, { useState } from 'react';
import { Modal, Button, Input, Select } from '../../components/ds';
import { useToast } from '../../components/ds';
import api from '../../api/client';

export default function PlacementTypeModal({ type, onClose, onSaved }) {
  const [name, setName] = useState(type?.name || '');
  const [displayName, setDisplayName] = useState(type?.display_name || '');
  const [platform, setPlatform] = useState(type?.platform || 'mobile');
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();

  const isEdit = !!type;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      addToast('Name is required');
      return;
    }

    setLoading(true);
    try {
      if (isEdit) {
        await api.updatePlacementType(type.id, { name, display_name: displayName, platform });
        addToast('Updated', 'success');
      } else {
        await api.createPlacementType({ name, display_name: displayName, platform });
        addToast('Created', 'success');
      }
      onSaved();
    } catch (err) {
      addToast('Failed: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal title={isEdit ? '編輯 Placement Type' : '新增 Placement Type'} onClose={onClose} footer={
      <>
        <Button variant="secondary" onClick={onClose}>取消</Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? '儲存中...' : '儲存'}
        </Button>
      </>
    }>
      <form onSubmit={handleSubmit}>
        <Input
          label="名稱 (英文識別碼)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. slider"
          required
        />
        <p style={{ margin: '4px 0 12px', fontSize: 'var(--font-size-sm)', color: 'var(--text-tertiary)', lineHeight: 'var(--line-height-normal)' }}>
          輸入的名稱需要與 ADISON 後台的 Placement Type 一致，例如 <code style={{ fontFamily: 'monospace', background: 'var(--bg-secondary)', padding: '1px 4px', borderRadius: 'var(--radius-sm)', whiteSpace: 'nowrap' }}>web_interstitial</code>。
        </p>

        <Input
          label="顯示名稱"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          placeholder="e.g. Slider 輪播"
        />

        <Select
          label="平台"
          value={platform}
          onChange={(e) => setPlatform(e.target.value)}
          options={[
            { value: 'mobile', label: 'Mobile' },
            { value: 'pc', label: 'PC' },
          ]}
        />
      </form>
    </Modal>
  );
}
